// extracted by mini-css-extract-plugin
export default {"report-host-tasks__container":"styles_report-host-tasks__container__nwGb+"};